<template>
  <transition name="fade" mode="out-in">
    <div v-if="resource.ready">
      <div class="card mb-5">
        <div class="card-title flex justify-between" v-once>
          <div v-if="editing">
            Заказ – #{{ entry.id }} ({{ entry.product.name }})
          </div>
          <div v-else>Создать заказ</div>

          <div>
            <a
                v-if="editing && entry.amo_link"
                :href="entry.amo_link"
                target="_blank"
                class="btn btn-pink"
            >Открыть в amoCRM</a
            >
          </div>
        </div>

        <form class="spaced-y-4" @submit.prevent="submit">
          <div class="flex -mx-2">
            <select-field
                :filter-by="productsFilterBy"
                class="w-1/2 px-2"
                title="Товар"
                label="name"
                valueName="id"
                :options="selects.products"
                v-model="entry.product_id"
                :errors="errors.product_id"
                :clearable="false"
                required
            />
            <search-select-field
                :filter-by="customersFilterBy"
                class="w-1/2 px-2"
                title="Клиент"
                label="label"
                valueName="id"
                :options="selects.customers"
                v-model="entry.customer_id"
                :errors="errors.customer_id"
                @input="setCustomer"
                :clearable="false"
                @search="fetchCustomers"
                required
            />
          </div>
          <p v-if="selectedProduct" class="pb-2">Цена товара: {{ selectedProduct.price }}</p>

          <template v-if="selectedProduct && selectedProduct.category_id === 1" >
            <div class="flex -mx-2">
              <select-field
                  class="w-1/2 px-2"
                  title="Чехол"
                  label="name"
                  valueName="id"
                  :options="cases"
                  v-model="entry.case_id"
                  :errors="errors.case_id"
              />
              <text-field
                  class="w-1/2 px-2"
                  title="Стоимость"
                  v-model="entry.case_amount"
                  :errors="errors.case_amount"
              />
            </div>
            <div class="flex -mx-2">
              <select-field
                  class="w-1/2 px-2"
                  title="Стойка"
                  label="name"
                  valueName="id"
                  :options="racks"
                  v-model="entry.rack_id"
                  :errors="errors.rack_id"
              />
              <text-field
                  class="w-1/2 px-2"
                  title="Стоимость"
                  v-model="entry.rack_amount"
                  :errors="errors.rack_amount"
              />
            </div>
          </template>

          <div v-for="(amount, index) in entry.amounts" class="flex -mx-2">
            <text-field
                class="w-1/2 px-2"
                title="Стоимость"
                v-model="amount.amount"
                required
            />

            <select-field
                class="w-1/2 px-2"
                title="Счет"
                label="name"
                valueName="id"
                :options="selects.accounts"
                v-model="amount.account_id"
                :clearable="false"
                required
            />
            <button class="btn btn-danger mb-2" @click.prevent="entry.amounts.splice(index, 1)">Удалить</button>
          </div>
          <button class="btn btn-blue mb-2" @click.prevent="entry.amounts.push({amount: null, account_id: 1})">Добавить оплату</button>

          <div v-for="(seller, index) in entry.sellers" class="flex -mx-2">
            <select-field
                class="w-1/2 px-2"
                title="Продавец"
                label="first_name"
                valueName="id"
                :options="selects.sellers"
                v-model="seller.id"
                :clearable="false"
                required
            />
            <button class="btn btn-danger mb-2" @click.prevent="entry.sellers.splice(index, 1)">Удалить</button>
          </div>
          <button class="btn btn-blue mb-2" @click.prevent="entry.sellers.push({...selects.sellers[0]})">Добавить продавца</button>

          <div class="flex -mx-2">
            <select-field
                class="w-1/2 px-2"
                title="Партнер"
                label="full_name"
                valueName="id"
                :options="selects.partners"
                :errors="errors.partner_id"
                v-if="entry.customer || editing"
                :disabled="editing"
                :clearable="!editing"
            />
          </div>

          <div class="flex -mx-2">
            <date-field
                class="w-1/2 px-2"
                title="Дата продажи"
                v-model="entry.sold_at"
                format="Y-m-d H:i:00"
                :time="true"
                displayFormat="H:i d.m.Y"
                :errors="errors.sold_at"
            />

            <text-field
                class="w-1/2 px-2"
                title="ID amoCRM"
                v-model="entry.amo_id"
                :errors="errors.amo_id"
                @input="handleAmoIdSelect"
            />
          </div>

          <textarea-field
              title="Откуда узнал"
              v-model="entry.from_who_note"
              :errors="errors.from_who_note"
          />

          <textarea-field
              title="Комментарий"
              v-model="entry.comment"
              :errors="errors.comment"
          />

          <hr class="mb-3"/>

          <div class="flex justify-between">
            <button :disabled="saving" class="btn btn-primary">
              Сохранить
            </button>

            <div class v-if="editing">
              <button
                  :disabled="saving"
                  v-if="!entry.is_paid"
                  @click.prevent="createInvoice"
                  class="btn btn-success"
              >
                Сформировать счет
              </button>
              <router-link
                  tag="button"
                  :to="{
                                    name: 'admin.billing.orders.replace',
                                    params: {
                                        id: entry.id,
                                    },
                                }"
                  class="btn btn-warning"
              >Заменить
              </router-link
              >

              <button
                  v-if="!entry.is_paid && this.can('pay-order')"
                  @click.prevent="payOrder"
                  class="btn btn-pink"
              >
                Оплатить
              </button>
            </div>

            <button
                v-if="editing"
                @click.prevent="destroy"
                class="btn btn-danger"
            >
              Удалить
            </button>
          </div>
        </form>
      </div>

      <invoices v-if="editing"/>
      <transactions
          v-if="can('access-transactions') && editing && false"
          modelType="order"
          :modelId="entry.id"
      />
      <create-customer-modal
          :show="showCustomerModal"
          @close="showCustomerModal = false"
          @create="createCustomer"
      />
      <activity
          modelType="order"
          :modelId="entry.id"
          :attributes="logAttributes"
          v-if="can('access-activity-log') && editing"
      />
    </div>
  </transition>
</template>

<script>
import ResourceForm from "@/components/Resource/ResourceForm";
import Transactions from "@/views/admin/billing/transactions/index";
import Invoices from "./invoices";
import CreateCustomerModal from "@/views/admin/customers/modal";
import Activity from "@/views/admin/activity/index";
import qs from "qs";

export default {
  extends: ResourceForm,

  components: {
    Transactions,
    Invoices,
    CreateCustomerModal,
    Activity,
  },

  data() {
    return {
      logAttributes: {
        amount: {
          label: "Стоимость",
        },
        comment: {
          label: "Комментарий",
        },
        customer_id: {
          label: "Клиент",
        },
        product_id: {
          label: "Товар",
        },
        seller_id: {
          label: "Продавец",
        },
        partner_id: {
          label: "Партнер",
        },
        account_id: {
          label: "Счет",
        },
        sold_at: {
          label: "Дата продажи",
        },
        paid_at: {
          label: "Дата оплаты",
        },
      },

      resource: {
        name: "admin.billing.orders",
        endpoint: "admin/billing/orders",
      },

      showCustomerModal: false,

      selects: {
        ready: false,
        accounts: [],
        products: [],
        customers: [],
        sellers: [],
        partners: [],
      },
    };
  },

  methods: {
    handleAmoIdSelect() {
      if (this.entry.amo_id) {
        axios.post('/admin/customers/get_by_amo_lead', {
          amo_id: this.entry.amo_id
        }).then((data) => {
          this.entry.customer_id = this.selects.customers.find((customer) => customer.amo_id == data.data).id

          this.setCustomer()

          this.$forceUpdate()
        })
      }
    },

    customersFilterBy(model, match, query) {
      return (
          //match.indexOf(query) !== -1 ||
          (model.amo_id && model.amo_id.indexOf(query) !== -1) ||
          (model.phone && model.phone.indexOf(query) !== -1)
      );
    },

    productsFilterBy(model, match, query) {
      return (
          match.indexOf(query) !== -1 ||
          (model.unique_id && model.unique_id.indexOf(query) !== -1)
      );
    },

    productsFilterByRack(model, match, query) {
      return (
          match.indexOf(query) !== -1 ||
          (model.unique_id && model.unique_id.indexOf(query) !== -1)
      );
    },

    onFetch() {
      if (
          !this.selects.products.find(
              (product) => product.id === this.entry.product_id
          )
      ) {
        this.selects.products.push(this.entry.product);
      }
    },

    payOrder() {
      axios
          .post(`/admin/billing/orders/${this.entry.id}/pay`)
          .then((response) => {
            this.entry.is_paid = true;
            this.$message.success("Заказ оплачен");
          });
    },

    createCustomer(customer) {
      this.selects.customers.push({
        ...customer,
        label: customer.full_name + ", " + customer.phone,
      });

      this.entry.customer_id = customer.id;
      this.showCustomerModal = false;
    },

    setCustomer(value) {
      this.entry.customer_id = value.id

      if (this.entry.customer_id === -1) {
        this.entry.customer_id = null;
        this.showCustomerModal = true;
      } else {
        this.entry.customer = value

        if (!this.editing) {
          this.entry.partner_id = this.entry.customer.partner_id;
          this.entry.seller_id = this.entry.customer.seller_id;
        }
      }
    },

    createInvoice() {
      this.saving = true;
      axios
          .post(`/admin/billing/orders/${this.entry.id}/invoice`)
          .then((response) => {
            this.saving = false;
            let invoiceId = response.data.data.id;

            this.$message.success("Счет сформирован");
            this.$router.push({
              name: "admin.billing.invoices.show",
              params: {
                id: invoiceId,
              },
            });
          })
          .catch((error) => {
            this.saving = false;
            if (error.response.data.message) {
              this.$message.error(error.response.data.message);
            } else {
              this.$message.error("Произошла ошибка");
            }
          });
    },
    async fetchSelects() {
      await this.fetchCustomers()

      await axios.get("/admin/assets/accounts/all").then((response) => {
        this.selects.accounts = response.data.data;
      });

      await axios
          .get("/admin/products/all", {
            params: {
              filters: {
                sellable: 1,
              },
            },
            paramsSerializer: (params) => {
              return qs.stringify(params);
            },
          })
          .then((response) => {
            this.selects.products.push(...response.data.data);
          });

      await axios
          .get("/admin/users/all", {
            params: {
              filters: {
                role: "partner",
              },
            },
            paramsSerializer: (params) => {
              return qs.stringify(params);
            },
          })
          .then((response) => {
            this.selects.partners = response.data.data;
          });

      await axios
          .get("/admin/users/all", {
            params: {
              filters: {
                amo: 1,
              },
            },
            paramsSerializer: (params) => {
              return qs.stringify(params);
            },
          })
          .then((response) => {
            this.selects.sellers = response.data.data;
          });

      this.selects.customers.unshift({
        id: -1,
        full_name: "Добавить клиента",
      });

      if (this.$route.params.productId) {
        this.$set(
            this.entry,
            "product_id",
            this.$route.params.productId
        );
      }

      this.selects.ready = true;
    },
  },

  created() {
    this.entry = {
      id: this.entry.id,
      amounts: [],
      sellers: []
    }
  },

  mounted() {
    this.entry.seller_id = this.$auth.user().id;
    this.fetchSelects();
  },

  watch: {
    "entry.product_id": {
      handler: function (value, oldValue) {
        if (this.selects.products.length) {
          let product = this.selects.products.find(
              (product) => product.id == this.entry.product_id
          );

          if (product) {
            this.entry.amount = product.price;
          }
        }
      },
      deep: true,
    },
    "entry.case_id": {
      handler: function () {
        if (this.cases) {
          const product = this.cases.find(product => product.id === this.entry.case_id);

          if (product) {
            this.entry.case_amount = product.price;
          }
        }
      }
    },
    "entry.rack_id": {
      handler: function () {
        if (this.cases) {
          const product = this.racks.find(product => product.id === this.entry.rack_id);

          if (product) {
            this.entry.rack_amount = product.price;
          }
        }
      }
    },
  },
  computed: {
    cases() {
      return this.selects.products.filter(product => product.category_id === 3)
    },
    racks() {
      return this.selects.products.filter(product => product.category_id === 5)
    },
    selectedProduct() {
      return this.selects.products.find(product => product.id === this.entry.product_id)
    },
    isAdmin() {
      return this.$auth.user().role.name == 'admin' || this.$auth.user().role.name == 'super-admin'
    }
  }
};
</script>
